var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 44,
    viewBox: "0 0 46 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 7",
    d: "M39.1415 42.189H17.1415C14.3801 42.189 12.1415 39.9504 12.1415 37.189V6.18897C12.1415 3.42754 14.3801 1.18896 17.1415 1.18896H30.4773L44.1415 14.8532V37.189C44.1415 39.9504 41.9029 42.189 39.1415 42.189Z",
    fill: "#F2F2F7",
    stroke: "#CBD0DC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 8",
    x: 0.641479,
    y: 19.189,
    width: 30,
    height: 17.5,
    rx: 3.5,
    fill: "#D82042"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PDF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.61353 32.1888V23.8252H8.5947C9.24539 23.8252 9.78445 23.9436 10.2119 24.1805C10.6393 24.4173 10.9592 24.7413 11.1716 25.1524C11.3839 25.5608 11.4901 26.0209 11.4901 26.5328C11.4901 27.0473 11.3826 27.5102 11.1675 27.9213C10.9551 28.3296 10.6339 28.6536 10.2037 28.8932C9.77629 29.1301 9.23858 29.2485 8.59062 29.2485H6.54055V28.1785H8.47627C8.88738 28.1785 9.22089 28.1077 9.47681 27.9662C9.73273 27.8219 9.92058 27.6259 10.0404 27.3781C10.1602 27.1304 10.2201 26.8486 10.2201 26.5328C10.2201 26.2169 10.1602 25.9365 10.0404 25.6915C9.92058 25.4465 9.73136 25.2545 9.47272 25.1157C9.2168 24.9768 8.87921 24.9074 8.45994 24.9074H6.87542V32.1888H5.61353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.677 32.1888H12.9695V23.8252H15.7628C16.5823 23.8252 17.2861 23.9926 17.8741 24.3275C18.4622 24.6597 18.9128 25.1375 19.2259 25.7609C19.5417 26.3817 19.6996 27.1263 19.6996 27.9948C19.6996 28.866 19.5403 29.6147 19.2218 30.2409C18.906 30.867 18.4486 31.3489 17.8496 31.6865C17.2507 32.0214 16.5265 32.1888 15.677 32.1888ZM14.2314 31.0862H15.6076C16.2447 31.0862 16.7742 30.9664 17.1962 30.7268C17.6182 30.4845 17.934 30.1347 18.1437 29.6773C18.3533 29.2172 18.4581 28.6563 18.4581 27.9948C18.4581 27.3386 18.3533 26.7819 18.1437 26.3245C17.9368 25.8671 17.6277 25.52 17.2166 25.2831C16.8055 25.0463 16.2951 24.9278 15.6852 24.9278H14.2314V31.0862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2688 32.1888V23.8252H26.4552V24.9115H22.5307V27.4598H26.0836V28.542H22.5307V32.1888H21.2688Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.35e1af748cd1b4df88783521d5838177.svg";
export { ForwardRef as ReactComponent };